import axios from 'axios';

export default class Base {
  public host: string;
  public ax: any;
  public resource = '';
  public additionalHeaders = {};

  constructor(host = process.env.VUE_APP_DEFAULT_API) {
    this.host = host;
    this.ax = axios.create({
      baseURL: this.host,
      headers: this.buildHeader(this.additionalHeaders),
      timeout: 0,
      responseType: 'json',
      transformRequest: [
        (data: any) => {
          return data;
        },
      ],
      transformResponse: [
        (data: any) => {
          if (!data) {
            const msg = 'Unknow Error';
            throw new Error(msg);
          }
          return data;
        },
      ],
    });
  }

  public index<T>(data?: any): Promise<T> {
    return this.get(this.host + this.resource, data);
  }

  public indexCsv<T>(data? :any): Promise<T> {
    return this.get(this.host + this.resource, data, {
      responseType: 'stream'
    });
  }

  public create<T>(data?: any, isForm: boolean = false): Promise<T> {
    return this.post(this.host + this.resource, data);
  }

  public get<T>(url: string, data?: any, options: any={}): Promise<T> {
    const identity = localStorage.getItem('token');
    return this.ax
    .get(url, {
      params: processData(data),
      headers: {
        Authorization: identity ? `Bearer ${identity}` : '',
        ...this.additionalHeaders,
      },
      ...options
    })
    .then((res: any) => {
      return res.data;
    })
    .catch((err: any) => {
      handleError(err);
      throw err;
    });
  }

  public post<T>(url: string, data?: any, isForm: boolean = false): Promise<T> {
    const identity = localStorage.getItem('token');

    data = processData(data);
    let contentType = 'application/json';

    if (isForm) {
      contentType = 'application/form-data';
    } else {
      data = JSON.stringify(data);
    }

    return this.ax
    .post(url, data, {
      headers: {
        'Authorization': identity ? `Bearer ${identity}` : '',
        'Content-Type': contentType,
        ...this.additionalHeaders,
      },
    })
    .then((res: any) => {
      return res.data;
    })
    .catch((err: any) => {
      handleError(err);
      throw err;
    });
  }

  public put<T>(url: string, data?: any, headers?: any): Promise<T> {
    const identity = localStorage.getItem('token');
    return this.ax
    .put(url, JSON.stringify(processData(data)), {
      headers: {
        Authorization: identity ? `Bearer ${identity}` : '',
        ...headers,
      },
    })
    .then((res: any) => {
      return res.data;
    })
    .catch((err: any) => {
      handleError(err);
      throw err;
    });
  }

  public delete<T>(url: string, data?: any, headers?: any): Promise<T> {
    const identity = localStorage.getItem('token');
    return this.ax
    .delete(url, {
      data: JSON.stringify(processData(data)),
      headers: {
        Authorization: identity ? `Bearer ${identity}` : '',
        ...headers,
      },
    })
    .then((res: any) => {
      return res.data;
    })
    .catch((err: any) => {
      handleError(err);
      throw err;
    });
  }

  private buildHeader(moreHeaders: any = {}): { [key: string]: string } {
    return {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': '*',
      ...moreHeaders,
    };
  }
}


/* tslint:disable-next-line */
function processData(data?: any) {
  if (data instanceof FormData) {
    // data.append('token', token)
  } else {
    // data.token = token
  }

  return data;
}

function handleError(err: any) {
  if (axios.isCancel(err)) {
    // handle cancel
  } else {
    // alert error
  }
}
